export function isMobile() {
  if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry/i)) {
    return true;
  }
  return false;
}
